import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    content: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',

      gap: '0.4rem',
    },
    notification: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'start',
      width: '100%',
      height: '32px',
      borderRadius: 5,
      gap: '1rem',
    },
    notificationText: {
      fontSize: '1.2rem',
      fontWeight: 400,
      wordWrap: 'break-word',
      marginRight: '1rem',
    },
    closeButton: {
      marginRight: '-0.4rem',
      marginTop: '-0.4rem',
      color: theme.palette.primary.dark,
    },

    footerContainer: {
      fontSize: '1.2rem',
      alignSelf: 'flex-end',
      gap: '0.8rem',

      fontWeight: 600,
      color: theme.palette.primary.dark,
    },
  }),
)
